import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import id from '../constant/language/id.json'
import en from '../constant/language/en.json'
import { getItem } from '../utility/LocalStorage'
const resources = {
  id,
  en,
}
const lng = getItem('language') ? getItem('language') : 'id'
i18n.use(initReactI18next).init({
  resources,
  lng: lng,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
